import { type EditorPlugin, type AhaEditor } from '@aha-app/aha-editor-v2';
import isHotkey from '@aha-app/is-hotkey';

const isCmdEnter = isHotkey('mod+enter');

const SubmitFormPlugin: EditorPlugin = {
  name: 'Submit form plugin',
  handlers: {
    onKeyDown(event: KeyboardEvent, ahaEditor: AhaEditor) {
      if (!isCmdEnter(event) || !ahaEditor.controller) {
        return false;
      }

      const { controller } = ahaEditor;
      const form = controller.editorContainer?.closest('form');

      if (!form) {
        return false;
      }

      const submitButton = form.querySelector<HTMLInputElement>(
        ':scope input[type=submit][name=commit]'
      );
      if (submitButton) {
        document.body.focus();
        submitButton.click();
        return true;
      }
    },
  },
};

export default SubmitFormPlugin;
